import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withErrorView } from '@bingads-webui-campaign-react/smart-page-error-boundary';

import { SmartActionButtonView } from './smart-action-button-view';

const getStyles = components => ({
  container: {
    ...components.section,
  },
  mainActionButton: {
    borderRadius: 100,
    height: 60,
    padding: '15px 34px 15px 34px',
    maxWidth: 360,
    fontSize: 24,
    lineHeight: '24px',
    fontWeight: 700,
  },
});

const UnStyledSmartMainActionButtonView = (props) => {
  const { classes, ...rest } = props;

  return (
    <div className={classes.container}>
      <SmartActionButtonView {...rest} className={classNames(classes.mainActionButton, 'smart-page-main-action-button')} />
    </div>
  );
};

UnStyledSmartMainActionButtonView.propTypes = {
  classes: PropTypes.shape({
    container: PropTypes.string,
  }).isRequired,
};

export const SmartMainActionButtonView = withErrorView(withDefaultStyles(
  UnStyledSmartMainActionButtonView,
  getStyles
), 'componentMode');
